import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseView } from '../../../../view/base-view';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { list, stack, build } from '../../../../common/classes/request-builder';
import { FincasApiService } from '../../../../service/api/fincas-api.service';
import { environment } from '../../../../../environments/environment';
import { ClientesApiService } from '../../../../service/api/clientes-api.service';
import { ProductosApiService } from '../../../../service/api/productos-api';
import { StorageManager } from '../../../../common/storage-manager.class';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { MessageService } from 'primeng/api';

import { ProductosModel } from 'src/app/models/productos/productos.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { CalendarioAbonadoModel } from 'src/app/models/tareas/calendario-abonado.model ';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ClienteModel } from 'src/app/models/cliente.model';
import { FertiAbonadoInterface } from './ferti-abonado.interface';
import { DropdownData } from '@fitogest/reactive-form-builder/interfaces';
import {
    clearDropdownSelected,
    getDropdownSelectedSingle,
    setDropdownSelected,
} from '@fitogest/reactive-form-builder/utils';
import { Subscription } from 'rxjs';

type MesCalendario = {
    label: string;
    value: number;
};

type CalendarioSelectOption<T extends string | number> = {
    label: string;
    value: T;
};

@Component({
    selector: 'app-calendario-abonado',
    standalone: false,
    templateUrl: './calendario-abonado.component.html',
    styleUrls: ['./calendario-abonado.component.scss']
})
export class CalendarioAbonadoComponent extends BaseView<CalendarioAbonadoModel> implements OnInit, OnDestroy {

    public fincaName = environment.features.fincaName;
    public logoUrl = environment.logoUrl;
    public user = StorageManager.getUser();
    public client = StorageManager.getClient();
    public hasSelectedClient = !!(this.client || {}).id;
    public tableData: number[] = [];
    public fincaSeleccionada = '';

    public totalKg: number[] = [];

    public semanasHead: number[] = [
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4
    ];
    public mesesHead: number[] = [
        0, 0, 0, 0,
        1, 1, 1, 1,
        2, 2, 2, 2,
        3, 3, 3, 3,
        4, 4, 4, 4,    
        5, 5, 5, 5,
        6, 6, 6, 6,
        7, 7, 7, 7,
        8, 8, 8, 8,
        9, 9, 9, 9,
        10, 10, 10, 10,
        11, 11, 11, 11
    ];
    public semanasOcultas: number[] = [];
    public mesesOcultos: number[] = [];

    public semanas: number[] = [];

public meses: MesCalendario[] = [
    { label: 'Enero', value: 1 },
    { label: 'Febrero', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Mayo', value: 5 },
    { label: 'Junio', value: 6 },
    { label: 'Julio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Septiembre', value: 9 },
    { label: 'Octubre', value: 10 },
    { label: 'Noviembre', value: 11 },
    { label: 'Diciembre', value: 12 },
];

    public clienteControl = new FormControl<string | null>(null);
    public fincaControl = new FormControl<string | null>(null);
    public mesesControl = new FormControl<number[]>([], { nonNullable: true });
    public anyoControl = new FormControl<string>(moment().format('YYYY'), { nonNullable: true });
    public edadControl = new FormControl<string | null>('');
    public observacionesControl = new FormControl<string | null>('');

    public duplicarClienteControl = new FormControl<string | null>(null);
    public duplicarFincaControl = new FormControl<string | null>(null);
    public duplicarAnyoControl = new FormControl<string>(moment().format('YYYY'), { nonNullable: true });

    public clienteOptions: CalendarioSelectOption<string>[] = [];
    public fincaOptions: CalendarioSelectOption<string>[] = [];
    public duplicarFincaOptions: CalendarioSelectOption<string>[] = [];
    public mesOptions: CalendarioSelectOption<number>[] = this.meses.map((mes) => ({
        label: mes.label,
        value: mes.value,
    }));
    public anyoOptions: CalendarioSelectOption<string>[] = [
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        '2026',
        '2027',
        '2028',
        '2029',
        '2030',
    ].map((anyo) => ({
        label: anyo,
        value: anyo,
    }));

    public abonadoControls: Record<string, FormControl<string | number | null>> = {};
    public areReactiveControlsReady = false;

    public abonados: CalendarioAbonadoModel[] = [];
    public abonadosTable: number[][] = [
        []
    ];
    public abonadosTableWithId: number[][] = [
        []
    ];

    public isPrinting = false;
    public isSaving = false;
    public hasSaved = false;
    public isDuplicating = false;

    public clientes: DropdownData<ClienteModel> = list();
    public fincas: DropdownData<FincasModel> = list();
    public sectores: DropdownData<SectorModel> = list();
    public parcelas: DropdownData<ParcelasModel> = list();
    public productos: DropdownData<ProductosModel> = list();
    public productosTabla: ProductosModel[] = [];
    public productosTablaFiltered: ProductosModel[] = [];

    public override model: CalendarioAbonadoModel = {
        plantas: 0,
        goteros: 0,
        caudal_gotero: 0,
        edad: '',
        anyo: moment().format('YYYY')
    };
    public modelMes: { ids_meses: number[] } = { ids_meses: [] };
    public modelDup: CalendarioAbonadoModel = {
        plantas: 0,
        goteros: 0,
        caudal_gotero: 0,
        edad: '',
        anyo: moment().format('YYYY')
    };
    public imprimirModel = {};

    private readonly reactiveControlSubscriptions = new Subscription();
    private abonadoControlSubscriptions = new Subscription();

    constructor(public tareasApi: TareasApiService,
        private dashboardEvents: DashboardService,
        public dashboard: DashboardService,
        private messageService: MessageService,
        public clientesApi: ClientesApiService,
        public fincasApi: FincasApiService,
        public productosApi: ProductosApiService) {
        super(dashboardEvents, tareasApi.tablaAbonado.GET, tareasApi.tablaAbonado.DELETE);
        for (let i = 1; i <= 48; i++) {
            this.semanas.push(i);
        }
    }

    ngOnInit(): void {
        this.dashboardEvents.changeClientActive = false;
        this.subscribeReactiveControls();
        this.tareasApi.tablaAbonado.GET.response(res => {
            if (this.isDuplicating) {
                return;
            }
            this.abonados = res;

            this.formatAbonado();
            this.getTotalKg();
        });

        stack([
            build(this.clientesApi.clientesGET, this.clientes, 'nombre', false),
            build(this.fincasApi.fincasGET, this.fincas, 'nombre', true),
            build(this.fincasApi.sectoresGET, this.sectores, 'nombre', false),
            build(this.fincasApi.parcelasGET, this.parcelas, 'nombre', false),
            build(this.productosApi.productos.GET, this.productos, 'nombre', false)
        ]).then(() => {
            this.productosTabla = this.productos.filtered
                .map(it => it.value as ProductosModel)
                .filter(it => it && it.tipo === 'fertilizante')
                .map((it) => { (it as ProductosModel).id = (it as ProductosModel).id ?? ''; return it;})
                .sort((a, b) => (+(a.subtipo ?? '') || 0) - (+(b.subtipo ?? '') || 0));

            if (this.hasSelectedClient) {
                this.model.id_cliente = this.client?.id ?? '';
                setDropdownSelected(this.clientes, StorageManager.getClient());
            }

            this.refreshSelectOptions();
            this.syncMainControlsFromModel();
            this.areReactiveControlsReady = true;

            if (this.hasSelectedClient) {
                this.formChanges('id_cliente');
            }
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );

        this.dashboard.setSubmenuItem('tareas', 'calendario-abonado');
    }

    public formChanges(tag?: string): void {
        if (tag === 'ids_meses') {
            this.mesesOcultos = [];
            this.semanasOcultas = [];
            (this.modelMes.ids_meses || []).forEach((modelIdMes: number) => {
                this.mesesOcultos.push(modelIdMes);
                Object.keys(this.mesesHead).forEach(key => {
                    if (this.mesesHead[+key] === modelIdMes) {
                        this.semanasOcultas.push(parseInt(key, 10) + 1);
                    }
                });
            });
        }

        if (tag === 'id_cliente') {
            this.model.id_finca = null;
        }
        if (['id_cliente', 'id_finca', 'anyo'].includes(tag ?? '')) {
            this.model.edad = null;
            this.model.observaciones = null;
            this.model.plantas = 0;
            this.model.goteros = 0;
            this.model.caudal_gotero = 0;

            this.modelMes.ids_meses = [];
            this.semanasOcultas = [];
            this.mesesOcultos = [];
            this.syncFreeTextControlsFromModel();
            this.mesesControl.setValue([], { emitEvent: false });

            const selectedFinca = this.selectedFinca;
            if (selectedFinca) {
                const idsProductos = ((selectedFinca || {}).ids_productos || '').split(';');
                this.productosTablaFiltered = this.productosTabla.filter(it => idsProductos.includes(it.id ?? ''));
        
                if (this.model.id_finca) {
                    this.fincaSeleccionada = selectedFinca.nombre.toUpperCase();
  
                    this.sectores.filtered
                        .filter(it => it.value)
                        .map(it => it.value as SectorModel)
                        .filter(it => it.id_finca === this.model.id_finca).forEach(it => {
                            this.model.goteros += parseInt(it.goteros || '', 10);
                            this.model.caudal_gotero += parseInt(it.caudal_gotero || '', 10);
                        });
                    this.parcelas.filtered
                        .filter(it => it.value)
                        .map(it => it.value as ParcelasModel)
                        .filter(it => it.id_finca === this.model.id_finca)
                        .forEach(it => {
                            this.model.plantas += parseInt(it.plantas || '', 10);
                        });
  
  
                    this.tareasApi.tablaAbonado.GET.perform({
                        id_finca: this.model.id_finca,
                        anyo: this.model.anyo || moment().year()
                    } as never);
                }
            }

        }
    }

    giveValue() {
        this.getTotalKg();
    }

    public async guardarAbonado(isDuplicating = false): Promise<boolean> {
        if ((this.abonadosTable || []).length <= 1) {
            alert('Debe añadir al menos una línea en la tabla de "Consumos planta / año" antes de guardar.');
            return false;
        }

        const selectedCliente = this.selectedCliente;
        const selectedFinca = this.selectedFinca;

        if (selectedCliente && selectedFinca) {
            this.isSaving = true;

            const fertis: FertiAbonadoInterface[] = [];
            this.abonadosTable.forEach((producto, idxProducto) => {
                producto.forEach((valor, idxValor) => {
                    const semana = this.semanas[idxValor - 1];
                    if (semana && this.abonadosTableWithId[idxProducto]) {
                        const ferti = {
                            id: this.abonadosTableWithId[idxProducto]
                                ? this.abonadosTableWithId[idxProducto]?.[idxValor]
                                : null,
                            id_producto: idxProducto,
                            id_finca: selectedFinca.id,
                            valor,
                            semana: this.semanasHead[idxValor - 1],
                            semana_full: semana,
                            mes: this.mesesHead[semana - 1],
                            anyo: this.model.anyo || moment().year(),
                            edad: this.model.edad,
                            observaciones: this.model.observaciones,
                            id_cliente: (selectedCliente.id || (StorageManager.getClient() as ClienteModel).id) ?? '',
                            id_usuario: StorageManager.getUser().id
                        };
    
                        fertis.push(ferti);
                    }
                });
            });

            fertis.forEach(async ferti => {
                if (isDuplicating) {
                    delete ferti.id;
                }
                try {
                    if (ferti && ferti.id) {
                        await this.tareasApi.tablaAbonado.PUT.perform(ferti);
                    } else {
                        await this.tareasApi.tablaAbonado.POST.perform(ferti);
                    }
                } catch (e) {
                    alert('Ha habido un error al guardar. Si este error persiste, por favor, contacte con un técnico.\n\nError: ' + e);
                    this.isSaving = false;
                    return false;
                }
                return false;
            });
            this.isSaving = false;

            setTimeout(() => {
                this.hasSaved = true;
            }, 700);
            setTimeout(() => {
                this.hasSaved = false;
                return true;
            }, 1700);
        } else {
            return false;
        }
        return false;
    }

    formatAbonado() {
        const fertis: number[][] = [];
        const fertisId: number[][] = [];

        this.abonados.forEach(ferti => {
            if (ferti.edad) {
                this.model.edad = ferti.edad;
            }
            if (ferti.observaciones) {
                this.model.observaciones = ferti.observaciones;
            }
            if (!fertis[parseInt(ferti.id_producto?.toString() ?? '', 10)]) {
                fertis[parseInt(ferti.id_producto?.toString() ?? '', 10)] = [];
                fertisId[parseInt(ferti.id_producto?.toString() ?? '', 10)] = [];
            }

            const semana = this.semanas[parseInt(ferti.semana_full?.toString() ?? '', 10) - 1];
            const fert = fertis[parseInt(ferti.id_producto?.toString() ?? '', 10)];
            const fertiId = fertisId[parseInt(ferti.id_producto?.toString() ?? '', 10)];
            if (semana && fertiId && fert) {
                fert[semana] = ferti.valor ?? 0;
                fertiId[semana] = +(ferti.id || 0);
            }
        });

        (this.productosTablaFiltered || []).forEach(producto => {
            if (producto && producto.id && !fertis[+producto.id]) {
                fertis[+producto.id] = [];
            }
        });

        fertis[0] = [];
        this.abonadosTable = fertis;
        this.abonadosTableWithId = fertisId;
        this.syncFreeTextControlsFromModel();
        this.resetAbonadoControls();

    }

    public getTotalKg() {
        this.totalKg = [];

        this.abonadosTable.forEach((abonado: number[], index) => {
            let sum = 0;
            if (abonado) {
                (abonado || [0]).forEach(row => {
                    if (row) {
                        sum += parseFloat(row.toString().replace(',', '.'));
                    }
                });
                this.totalKg[index] = sum;
            }
        });
    }

    public checkNumberFormat(value: string | number) {
        const patt = new RegExp('^d+(d+)?$');

        if (!patt.test(value.toString())) {
            value = 0;
        }

    // if (!(event.code.includes('Digit') || event.code === 'Comma')) {
    //   return;
    // }
    }

    public replaceComma(str: string) {
        return +(str || '').replace(',', '.');
    }

    public imprimirPlan() {
        this.isPrinting = true;
        setTimeout(async () => {
            await html2canvas(document.getElementById('html2canvasDiv') ?? new HTMLElement(), {scale: 2, logging: false}).then(canvas => {
                const pdf = new jsPDF('l', 'mm', 'a4');
                const data = canvas.toDataURL('image/jpeg');
                pdf.addImage(data, 'jpg', 0, 0, 290, (canvas.height / (canvas.width / 290)), 'alias', 'FAST');
                pdf.save('Plan de abonado ' + this.fincaSeleccionada + ' ' + this.model.anyo);
  
                this.isPrinting = false;
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        }, 100);
    }

    public async enviarCorreo() {
        this.isPrinting = true;
        let email = '';
        let adjunto = '';
        await html2canvas(document.getElementById('html2canvasDiv') ?? new HTMLElement(), {scale: 2, logging: false}).then(async canvas => {
            this.isPrinting = false;

            const pdf = new jsPDF('l', 'mm', 'a4');
            const data = canvas.toDataURL('image/jpeg');
            pdf.addImage(data, 'jpg', 0, 0, 290, (canvas.height / (canvas.width / 290)), 'alias', 'FAST');
            adjunto = encodeURIComponent(window.btoa(pdf.output()));

            email = this.selectedEmail;
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        ).then(() => {
            console.log('Adjuntos generados.');
            return;
        }, error => {
            console.log(error);

            this.isPrinting = false;
            this.tareasApi.enviarRecetaCaptura.hasError = true;
            this.tareasApi.enviarRecetaCaptura['error'] = 'Error al envíar email';
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );

        if (email !== '') {
            await this.tareasApi.enviarRecetaCaptura.toPromise({
                email,
                generado: adjunto,
                finca: this.selectedFinca?.nombre,
                tratamiento: 'Plan de Abonado ' + this.selectedFincaName + ' ' + this.model.anyo
            } as never).then(() => {
                this.showSuccess('Email enviado.', 'Se ha enviado el plan de abonado a ' + email + '.');
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        } else {
            this.tareasApi.enviarRecetaCaptura.hasError = true;
            this.tareasApi.enviarRecetaCaptura['error'] = 'El cliente no tiene email';
        }
    }

    public override show(modal: string): void {
        this.modelDup = Object.assign({}, this.model);
        this.syncDuplicateControlsFromModel();
        this.modelMes.ids_meses = [];
        this.semanasOcultas = [];
        this.mesesOcultos = [];
        super.show(modal, this.model);
    }

    public showSuccess(summary: string, detail: string, severity = 'success'): void {
        this.messageService.add({summary, detail, severity});
    }


    public override ngOnDestroy(): void {
        this.reactiveControlSubscriptions.unsubscribe();
        this.abonadoControlSubscriptions.unsubscribe();
        super.ngOnDestroy();
    }

    public getAbonadoControl(productId: string | number | null | undefined, semana: number): FormControl<string | number | null> {
        const productIndex = this.toTableIndex(productId);
        const key = this.getAbonadoControlKey(productIndex, semana);
        const existingControl = this.abonadoControls[key];

        if (existingControl) {
            return existingControl;
        }

        const control = new FormControl<string | number | null>(this.abonadosTable[productIndex]?.[semana] ?? null);
        this.abonadoControls[key] = control;
        this.abonadoControlSubscriptions.add(control.valueChanges.subscribe((value) => {
            this.setAbonadoTableValue(productIndex, semana, value);
            this.getTotalKg();
        }));

        return control;
    }

    public get selectedFinca(): FincasModel | null {
        return getDropdownSelectedSingle(this.fincas);
    }

    public get selectedCliente(): ClienteModel | null {
        return getDropdownSelectedSingle(this.clientes);
    }

    public get hasSelectedFincaAndCliente(): boolean {
        return this.selectedFinca !== null && this.selectedCliente !== null;
    }

    public get selectedFincaName(): string {
        return this.selectedFinca?.nombre ?? '';
    }

    public get selectedEmail(): string {
        return this.selectedFinca?.email || this.selectedCliente?.email || '';
    }

    private subscribeReactiveControls(): void {
        this.reactiveControlSubscriptions.add(this.clienteControl.valueChanges.subscribe((idCliente) => {
            this.setMainClientId(idCliente);
            setDropdownSelected(this.clientes, this.findSelectedById(this.clientes, idCliente));
            this.model.id_finca = null;
            clearDropdownSelected(this.fincas);
            this.fincaControl.setValue(null, { emitEvent: false });
            this.updateFincaOptions();
            this.formChanges('id_cliente');
        }));

        this.reactiveControlSubscriptions.add(this.fincaControl.valueChanges.subscribe((idFinca) => {
            this.model.id_finca = idFinca;
            setDropdownSelected(this.fincas, this.findSelectedById(this.fincas, idFinca));
            this.formChanges('id_finca');
        }));

        this.reactiveControlSubscriptions.add(this.mesesControl.valueChanges.subscribe((idsMeses) => {
            this.modelMes.ids_meses = idsMeses;
            this.formChanges('ids_meses');
        }));

        this.reactiveControlSubscriptions.add(this.anyoControl.valueChanges.subscribe((anyo) => {
            this.model.anyo = anyo;
            this.formChanges('anyo');
        }));

        this.reactiveControlSubscriptions.add(this.edadControl.valueChanges.subscribe((edad) => {
            this.model.edad = edad;
        }));

        this.reactiveControlSubscriptions.add(this.observacionesControl.valueChanges.subscribe((observaciones) => {
            this.model.observaciones = observaciones;
        }));

        this.reactiveControlSubscriptions.add(this.duplicarClienteControl.valueChanges.subscribe((idCliente) => {
            this.setDuplicateClientId(idCliente);
            this.duplicarFincaControl.setValue(null, { emitEvent: false });
            this.modelDup.id_finca = null;
            this.updateDuplicarFincaOptions();
        }));

        this.reactiveControlSubscriptions.add(this.duplicarFincaControl.valueChanges.subscribe((idFinca) => {
            this.modelDup.id_finca = idFinca;
        }));

        this.reactiveControlSubscriptions.add(this.duplicarAnyoControl.valueChanges.subscribe((anyo) => {
            this.modelDup.anyo = anyo;
        }));
    }


    private setMainClientId(idCliente: string | null): void {
        if (idCliente === null) {
            delete this.model.id_cliente;
            return;
        }

        this.model.id_cliente = idCliente;
    }

    private setDuplicateClientId(idCliente: string | null): void {
        if (idCliente === null) {
            delete this.modelDup.id_cliente;
            return;
        }

        this.modelDup.id_cliente = idCliente;
    }

    private refreshSelectOptions(): void {
        this.clienteOptions = this.toSelectOptions(this.clientes);
        this.updateFincaOptions();
        this.updateDuplicarFincaOptions();
    }

    private updateFincaOptions(): void {
        const idCliente = this.hasSelectedClient
            ? this.toStringId(this.client?.id)
            : this.clienteControl.value;

        this.fincaOptions = this.getFincaOptions(idCliente, this.hasSelectedClient);
    }

    private updateDuplicarFincaOptions(): void {
        const idCliente = this.hasSelectedClient
            ? this.toStringId(this.client?.id)
            : this.duplicarClienteControl.value;

        this.duplicarFincaOptions = this.getFincaOptions(idCliente, this.hasSelectedClient);
    }

    private getFincaOptions(idCliente: string | null, showAllForSelectedClient: boolean): CalendarioSelectOption<string>[] {
        return (this.fincas.filtered || [])
            .filter((item) => {
                const finca = item.value;

                if (!finca) {
                    return false;
                }

                if (showAllForSelectedClient) {
                    return true;
                }

                return idCliente !== null && this.toStringId(finca.id_cliente) === idCliente;
            })
            .map((item) => ({
                label: item.label,
                value: this.toStringId(item.value?.id) ?? '',
            }))
            .filter((option) => option.value !== '');
    }

    private toSelectOptions<T extends { id?: string | number | null }>(data: DropdownData<T>): CalendarioSelectOption<string>[] {
        return (data.filtered || [])
            .map((item) => ({
                label: item.label,
                value: this.toStringId(item.value?.id) ?? '',
            }))
            .filter((option) => option.value !== '');
    }

    private findSelectedById<T extends { id?: string | number | null }>(data: DropdownData<T>, id: string | null): T | null {
        if (id === null) {
            return null;
        }

        return (data.filtered || [])
            .map((item) => item.value)
            .find((value): value is T => !!value && this.toStringId(value.id) === id) ?? null;
    }

    private syncMainControlsFromModel(): void {
        this.clienteControl.setValue(this.toStringId(this.model.id_cliente), { emitEvent: false });
        this.updateFincaOptions();
        this.fincaControl.setValue(this.toStringId(this.model.id_finca), { emitEvent: false });
        this.anyoControl.setValue(this.model.anyo || moment().format('YYYY'), { emitEvent: false });
        this.mesesControl.setValue([...(this.modelMes.ids_meses || [])], { emitEvent: false });
        this.syncFreeTextControlsFromModel();
    }

    private syncFreeTextControlsFromModel(): void {
        this.edadControl.setValue(this.model.edad ?? '', { emitEvent: false });
        this.observacionesControl.setValue(this.model.observaciones ?? '', { emitEvent: false });
    }

    private syncDuplicateControlsFromModel(): void {
        const idCliente = this.hasSelectedClient
            ? this.toStringId(this.client?.id)
            : this.toStringId(this.modelDup.id_cliente);

        this.duplicarClienteControl.setValue(idCliente, { emitEvent: false });
        this.updateDuplicarFincaOptions();
        this.duplicarFincaControl.setValue(this.toStringId(this.modelDup.id_finca), { emitEvent: false });
        this.duplicarAnyoControl.setValue(this.modelDup.anyo || moment().format('YYYY'), { emitEvent: false });
    }

    private resetAbonadoControls(): void {
        this.abonadoControlSubscriptions.unsubscribe();
        this.abonadoControlSubscriptions = new Subscription();
        this.abonadoControls = {};
    }

    private getAbonadoControlKey(productIndex: number, semana: number): string {
        return productIndex + '-' + semana;
    }

    private setAbonadoTableValue(productIndex: number, semana: number, value: string | number | null): void {
        if (!this.abonadosTable[productIndex]) {
            this.abonadosTable[productIndex] = [];
        }

        const row = this.abonadosTable[productIndex];

        if (row) {
            row[semana] = this.replaceComma((value ?? 0).toString());
        }
    }

    private toTableIndex(value: string | number | null | undefined): number {
        const parsedValue = parseInt((value ?? 0).toString(), 10);

        return Number.isNaN(parsedValue) ? 0 : parsedValue;
    }

    private toStringId(value: string | number | null | undefined): string | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        return value.toString();
    }

    public async duplicarPlan() {
        this.isDuplicating = true;
        await this.tareasApi.tablaAbonado.GET.toPromise({
            id_finca: this.modelDup.id_finca,
            anyo: this.modelDup.anyo
        } as never).then(res => {
            if (res && res.length > 0) {
                if (!confirm('ATENCIÓN: Ya hay datos para este cliente, finca y año. ¿Desea sobrescribirlos?')) {
                    this.isDuplicating = false;
                    return;
                }
            }
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
        // Asignamos el cliente, finca y año a duplicar al modelo prinicipal ahora, para no
        // disparar los eventos de formChanges()
        Object.keys(this.modelDup).forEach(key => {
            this.model[key] = this.modelDup[key] ?? '';
        });
        this.guardarAbonado(true).then(() => {
            this.showSuccess('Duplicar plan de abonado', 'Se ha duplicado el plan de abonado con éxito.');
            this.canShow['duplicar'] = false;
            this.isDuplicating = false;
            return;
        }, (error) => {
            console.log(error);
            this.isDuplicating = false;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }

}